import gql from 'graphql-tag';

export const GET_BADGE_BANNER_DATA = gql`
  query getBadgeBannerData {
    reviewPage {
      banner {
        title
        content
      }
      badge {
        code
        rating
        reviewCount
        url
      }
    }
  },
`;

export const GET_CONTACT_DETAIL_DATA = gql`
  query getContactDetailData {
    reviewPage {
      contact {
        details {
          key
          label
          value
        }
        socialLinks {
          key
          label
          value
        }
      }
      description
    }
  },
`;

export const GET_REVIEW_ITEM_DATA = gql`
  query getReviewData(
    $page: Int,
    $filter: ReviewFilter,
    $sortBy: ReviewSort
  ) {
    reviewPage{
      reviewItems(
      page: $page,
      filter: $filter,
      sortBy: $sortBy
    ) {
        itemsCount
        perPage
        page
        items {
          id
          customer_name
          desc
          date
          rating
          type
        }
      }
      titleDetails {
        rating
        allReviewCount
        googleReviewCount
        address
      }
    }
  }
`;
